import React from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';

const RelevantCaseStudies = ({ data }) => {

  return (
    <Wrapper>
      <SectionTitle style={{ marginLeft: '0em' }}>Relevant Case Studies</SectionTitle>
      <CaseStudies>
        {data.map((caseStudy, index) => {
          const { previewImage, company, whatWeDid, alt, slug } = caseStudy;
          return (
            <PreviewLink to={`/our-work/${slug.current}`}>
              <CaseStudyPreview
                key={index}
                variants={caseStudyPreviewVariants}
                whileHover="hover"
                whileTap="tap"
                layout>
                <GatsbyImage image={getImage(previewImage.asset.gatsbyImageData)} alt={alt} />
                <motion.h4 variants={caseStudyPreviewVariants}>{company}</motion.h4>
                <motion.p variants={caseStudyPreviewVariants}>{whatWeDid}</motion.p>
                <SeeMore variants={caseStudyPreviewVariants}>
                  See case study
                  <Seperator />
                </SeeMore>
              </CaseStudyPreview>
            </PreviewLink>
          );
        })}
      </CaseStudies>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 6.5rem;
  @media only screen and (max-width: 48rem) {
    margin-bottom: 3.75rem;
  }
`;

const SectionTitle = styled.h3`
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 0.0185em;
  margin: 1em auto;
  text-transform: lowercase;
`;



const CaseStudies = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  @media only screen and (max-width: 30rem) {
    flex-direction: column;
    > a:first-of-type {
      margin-bottom: 2.75rem;
    }
  }
`;

export const CaseStudyPreview = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  width: 100%;
  .gatsby-image-wrapper {
    max-width: 340px;
  }
  p {
    font-size: 0.75rem;
    margin: 0.5rem 0 1.25rem 0;
  }
  h4 {
    color: var(--ax-black);
    font-size: 2rem;
    font-weight: 300;
    margin-top: 0.5rem;
  }
  @media only screen and (max-width: 48rem) {
    h4 {
      font-size: 1.25rem;
    }
  }
`;

export const PreviewLink = styled(Link)`
  color: var(--ax-black);
  height: auto;
  text-decoration: none;
  width: calc(100% - 5rem);
  margin-right: 3rem;
  &:last-child {
    margin-right: 0;
  }
  @media only screen and (max-width: 48rem) {
    width: calc(100% - 1rem);
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const SeeMore = styled(motion.div)`
  display: flex;
  color: var(--ax-black);
  flex-direction: column;
  font-weight: 700;
  margin-top: auto;
  text-transform: uppercase;
  width: 100%;
`;

export const Seperator = styled.div`
  background-color: var(--ax-black);
  height: 0.063rem;
  margin: 0.2rem 0;
  transition: background-color 150ms ease-in-out;
  width: 50%;
`;

export const caseStudyPreviewVariants = {
  hover: {
    cursor: 'pointer',
    scale: 1.02,
    transition: {
      type: 'tween',
      ease: 'easeInOut',
      duration: 0.3
    }
  }
};

export default RelevantCaseStudies;
